import { Alert, Form } from 'react-bootstrap'
import PropTypes, { array, string } from 'prop-types'
import { LabelFor } from './LabelFor.jsx'

export const Select = (props) => {
    return (
        <Form.Group className={`w-100 ${props.className || ''}`}>
            {!props.hideLabel && (
                <LabelFor
                    label={props.label}
                    id={props.id}
                    tooltipText={props.tooltipText}
                />
            )}
            <Form.Select
                className={`form-select ${props.className} ${
                    props.errorText ? 'border-danger' : ''
                }`}
                id={props.id || props.name || props.ariaLabel || props.label}
                aria-label={props.label || props.title || 'wybierz'}
                title={props.title}
                as='input'
                readOnly={props.readOnly}
                size={props.size}
                data-testid={props.dataTestId}
                onChange={props.onChange}
                value={props.value}
                disabled={props.disabled}
            >
                {!props.noEmpty && <option></option>}
                {props.options?.length &&
                    props.options.map((s, idx) => (
                        <option
                            key={idx}
                            disabled={s?.disabled}
                            value={s?.value || s?.id}
                        >
                            {props.showId && s?.id ? `[${s?.id}]` : null}{' '}
                            {s?.label || s?.nazwa || s?.value}
                        </option>
                    ))}
            </Form.Select>

            {props.errorText && (
                <Alert className={'p-1 w-100'} variant={'danger'}>
                    <div className={'ms-1'}> {props.errorText}</div>
                </Alert>
            )}
        </Form.Group>
    )
}

Select.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,
    label: PropTypes.string,
    endpoint: PropTypes.string,
    disabled: PropTypes.bool,
    options: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    errorText: PropTypes.oneOfType([string, array]),
    showId: PropTypes.bool,
    className: PropTypes.string,
    noEmpty: PropTypes.bool,
    title: PropTypes.string,
    readOnly: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
    ariaLabel: PropTypes.string,
    size: PropTypes.string,
    dataTestId: PropTypes.string,
    tooltipText: PropTypes.string,
    hideLabel: PropTypes.bool,
}
